import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography, Box } from "@mui/material";
import CaseStudy3 from "../../../images/CaseStudy3.png";
import CaseStudy4 from "../../../images/CaseStudy4.png";

const SolImplementation: any = (props: any) => {
  const { pageData } = props;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex: 1,
        position: "relative",
        backgroundPosition: "inherit",
        width: "100%",
      }}
      pt={2}
    >
      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: { xs: "column", md: "row" },
          flexGrow: 1,
          padding: { xs: "5px", sm: "5px", md: "0px" },
          width: "100%",
        }}
      >
        {/* Image section - Now on the left */}
        <Grid
          size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
          sx={{
            order: { xs: 1, md: 1 },
            position: "relative",
            padding: { xs: "20px", md: "40px" },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "#0A1A3C",
              fontSize: "25px",
              lineHeight: 1.6,
              textAlign: { xs: "left" },
            }}
          >
            <b>Implementation</b>
          </Typography>

          <Typography
            variant="body1"
            sx={{ color: "#0A1A3C", fontSize: "17px", lineHeight: 1.6 }}
            dangerouslySetInnerHTML={{
              __html:
                pageData?.solutionsDetails?.blogBlock4?.leftSideContent
                  ?.description,
            }}
          />
          <Typography
            variant="body1"
            sx={{ color: "#0A1A3C", fontSize: "17px", lineHeight: 1.6 }}
          />
        </Grid>
        <Grid
          size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
          sx={{
            position: "relative",

            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            paddingBottom: { xs: "20px", md: 0 },
            order: { xs: 2, md: 2 },
          }}
        >
          <Box
            sx={{
              position: "absolute",

              right: 0,
              top: 0,
              width: { xs: "60%", md: "40%" },
              height: "100%",
              zIndex: 1,
              backgroundColor: "#0065FF",
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              zIndex: 2,
              justifyContent: "space-around",
              position: "relative",
            }}
          >
            <Box
              component="img"
              // src={CaseStudy3}
              src={
                pageData?.solutionsDetails?.blogBlock4?.rightSideContent &&
                pageData?.solutionsDetails?.blogBlock4?.rightSideContent
                  .images?.[0]?.url
                  ? process.env.REACT_APP_API_BASE_URL +
                    pageData?.solutionsDetails?.blogBlock4?.rightSideContent
                      .images?.[0]?.url
                  : CaseStudy4
              }
              alt="Application 1"
              sx={{
                padding: 2,
                maxWidth: 600,
                // height: { xs: "auto", md: "350px" },
                width: "100%",
                objectFit: "contain",
                mt: { xs: "15px", md: "15px", lg: 0 },
              }}
            />
            <Box
              component="img"
              // src={CaseStudy4}
              src={
                pageData?.solutionsDetails?.blogBlock4?.rightSideContent &&
                pageData?.solutionsDetails?.blogBlock4?.rightSideContent
                  .images?.[1]?.url
                  ? process.env.REACT_APP_API_BASE_URL +
                    pageData?.solutionsDetails?.blogBlock4?.rightSideContent
                      .images?.[1]?.url
                  : CaseStudy4
              }
              alt="Application 2"
              sx={{
                padding: 2,
                maxWidth: 600,
                width: "100%",
                objectFit: "contain",
                mt: { xs: "15px", md: "15px", lg: 0 },

                // height: { xs: "287px", sm: "287px", md: "247px" },
                // width: { xs: "360px", sm: "397px", md: "480px" },
              }}
            />
          </Box>
        </Grid>

        {/* Application text section - Now on the right */}
      </Grid>
    </Box>
  );
};

export default SolImplementation;
